<template>
  <div class="search-bar">
    <label v-if="hasLabel" class="search-bar__label">{{ label }}</label>

    <div id="search-container" class="search-bar__container">
      <SearchIcon class="search-bar__search-icon" />

      <input
        id="searchInput"
        v-model.trim="input"
        :placeholder="searchText"
        :data-cy="dataCy"
        class="prompt search-prompt search-bar__input"
        type="text"
        :aria-label="searchText"
        @input="updateQuery"
      />
    </div>
  </div>
</template>

<script>
/**
 * @deprecated - use BaseTextInput component instead
 */
import { debounce } from 'lodash-es'
import SearchIcon from '../icon_components/SearchIcon.vue'

export default {
  name: 'SearchBar',
  components: {
    SearchIcon,
  },
  props: {
    searchQuery: {
      type: String,
      default: '',
    },
    searchText: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    dataCy: {
      type: String,
      required: false,
      default: '',
    },
  },
  emits: ['updateQuery'],
  data() {
    return {
      input: this.searchQuery,
    }
  },
  computed: {
    hasLabel() {
      return this.label.length > 0
    },
  },
  beforeUnmount() {
    this.$emit('updateQuery', {
      name: this.name,
      value: '',
    })
  },
  methods: {
    updateQuery: debounce(function () {
      this.$emit('updateQuery', {
        name: this.name,
        value: this.input,
      })
    }, 500),
  },
}
</script>

<style lang="scss" scoped>
.search-bar {
  &__label {
    display: block;
    @include formLabelStyle;
  }
  &__container {
    position: relative;
  }
  &__search-icon {
    position: absolute;
    top: 11px;
    left: 12px;
    color: $color-text-light;
    width: $spacing-2xs;
    height: $spacing-2xs;
  }
  &__input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    display: inline-block;
    width: 100%;
    padding: $formElementsPaddingVertical 0 $formElementsPaddingVertical 36px;
    background: $formElementsBackground;
    border: $formElementsBorder;
    border-radius: $formElementsBorderRadius;
    color: $color-text;
    font-weight: $formElementsFontWeight;
    font-size: $formElementsFontSize;
    outline: none;
    line-height: $spacing-xs;

    &:focus {
      outline: none;
      border-color: $color-navigation;
    }
  }
}
</style>
